import Header from '../../../../Components/Header'
import Footer from '../../../../Components/Footer'
import MainContent from './MainContent'
import { Helmet } from 'react-helmet'

const Putaway = () => {
  
  return (
    <div className='d-flex flex-column' style={{ height: '100vh' }}>
      <Helmet>
        <title>Putaway List</title>
      </Helmet>
    <Header />
    <MainContent />
    {/* <Footer /> */}
    </div>
  )
}

export default Putaway